import { render, staticRenderFns } from "./ScheduleServicePackageWeek.vue?vue&type=template&id=ff252bee&scoped=true"
import script from "./ScheduleServicePackageWeek.vue?vue&type=script&lang=js"
export * from "./ScheduleServicePackageWeek.vue?vue&type=script&lang=js"
import style0 from "./ScheduleServicePackageWeek.vue?vue&type=style&index=0&id=ff252bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff252bee",
  null
  
)

export default component.exports